import { LeftOutlined } from "@ant-design/icons";
import styles from "./hasUser.module.scss";
import { UserLogin } from "../../../assets/fonts/icon/icons";
import { complexDigitToman, isEmptyObject } from "../../../tools/tools";
import MenuBar from "../menu/MenuBar";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../address";
import { useLayouts } from "../layouts";
import { useEffect } from "react";
import axios from "axios";
const HasUser = ({ userInfo = {} }) => {
  const nav = useNavigate();
  const { refreshUser } = useLayouts();

  return (
    <>
      <div className={styles.singhold}>
        <div className={styles.singinUser}>
          <div className={styles.rowInfo}>
            <div className={styles.holder_icon}>
              <UserLogin />
            </div>
            {!isEmptyObject(userInfo) ? (
              <div className={styles.profile} onClick={(e) => refreshUser(true)}>
                <div className={styles.hoder_name}>{`${userInfo?.firstname} ${userInfo?.lastname}`}</div>
                <div className={styles.balance}>
                  اعتبار:
                  <span>{complexDigitToman(userInfo?.walletAmount)} </span>
                  تومان
                </div>
              </div>
            ) : (
              <div
                onClick={(e) => {
                  nav(_adr.Root + _adr.Security.Login);
                }}
                className={styles.holder_text}
              >
                ورود حساب کاربری
                <LeftOutlined />
              </div>
            )}
          </div>
        </div>
        {!isEmptyObject(userInfo) && <MenuBar users={userInfo} />}
      </div>
    </>
  );
};

export default HasUser;
